"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  KB_JWT_TYP: () => KB_JWT_TYP,
  SD_DECOY: () => SD_DECOY,
  SD_DIGEST: () => SD_DIGEST,
  SD_LIST_KEY: () => SD_LIST_KEY,
  SD_SEPARATOR: () => SD_SEPARATOR
});
module.exports = __toCommonJS(src_exports);

// src/type.ts
var SD_SEPARATOR = "~";
var SD_LIST_KEY = "...";
var SD_DIGEST = "_sd";
var SD_DECOY = "_sd_decoy";
var KB_JWT_TYP = "kb+jwt";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  KB_JWT_TYP,
  SD_DECOY,
  SD_DIGEST,
  SD_LIST_KEY,
  SD_SEPARATOR
});
